
export class TypingIntro {
    /**
     * 
     * @param {HTMLElement | null} typingTextElement 
     */
    constructor(typingTextElement, text) {
        this.typingTextElement = typingTextElement;
        this.textSpan = document.createElement("span");
        this.cursorSpan = document.createElement("span");
        this.cursorSpan.classList.add("typing-cursor");
        this.cursorSpan.textContent = "|";
        this._onToastHidden = () => this.stopCursorBlink();
        window.addEventListener('toastHidden', this._onToastHidden);
    }

    startTyping() {
        if (!this.typingTextElement) {
            return;
        }

        // Ensure the spans are attached once so we can keep the cursor blinking
        if (!this.textSpan.parentNode) {
            this.typingTextElement.textContent = "";
            this.typingTextElement.appendChild(this.textSpan);
            this.typingTextElement.appendChild(this.cursorSpan);
        }

        this.textSpan.textContent = "";
        this.cursorSpan.classList.remove("cursor-paused");

        const firstPart = "Hi,";
        const secondPart = " I'm Spencer.";
        const letterDelay = 50; // Delay between each letter (in milliseconds)
        const partDelay = 850; // Delay between the two parts (in milliseconds)

        // Type the first part
        this._typeString(firstPart, 0, letterDelay, () => {
            // After the first part, wait for a bit
            setTimeout(() => {
                // Then type the second part
                this._typeString(secondPart, 0, letterDelay);
            }, partDelay);
        });
    }

    _typeString(string, index, delay, onComplete) {
        if (index < string.length) {
            this.textSpan.textContent += string[index];
            setTimeout(() => this._typeString(string, index + 1, delay, onComplete), delay);
        } else {
            if (onComplete) {
                onComplete();
            }
        }
    }

    stopCursorBlink() {
        this.cursorSpan.classList.add("cursor-paused");
    }
}
